import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import clientinvoiceApiController from "../../services/clientinvoice.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";

export const ClientInvoiceListViewApi = createAsyncThunk("clientinvoice/listview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientinvoiceApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "listview"))
      .catch((error) => HandleError(thunkAPI, error, "listview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientInvoiceDetailApi = createAsyncThunk("clientinvoice/detailview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientinvoiceApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "detailview"))
      .catch((error) => HandleError(thunkAPI, error, "detailview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientHideInvoiceApi = createAsyncThunk("clientinvoice/hideinvoice", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientinvoiceApiController
      .hideInvoice(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "hideinvoice"))
      .catch((error) => HandleError(thunkAPI, error, "hideinvoice"));
    const adminFlag = ["true", "1", "yes"].includes(String(localStorage.getItem("ADMIN") || "").toLowerCase());
    return {
      ...resposedata,
      id: formValues && formValues.id ? formValues.id : undefined,
      is_active: formValues && formValues.is_active !== undefined ? formValues.is_active : 0,
      adminClientInvoice: adminFlag,
    };
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isListView: [],
  isOpenClientInvoiceDetailsTab: "",
  isClientInvoiceDetailsTabData: "",
  isOpenClientInvoiceRefundModal: "",
  isOpenClientInvoiceStripePayModalClient: "",
  isOpenStripeRefundCompletedSaleModal: "",
  isCompletedSaleDataForRefund: "",
  isdepositBalance: "",
  isSaleCompletedData: "",
  AppointmentsData: "",
  appointmentsArray: "",
  isOpenPartialPaidInvoice: "",
  isActiveBtnState: "",
  isRefundStripeToken: "",
  isOpenStripeRefundModal: "",
  isRefundBalance: "",
  isTaxAmountClientPaidInvoice: "",
  isClientMemberShipTotalPay: "",
  totalServiceCosts: "",
  isFullCartData: "",
  isClientInvoiceDetail: "",
  isInvoiceRedirectLoading: false,
  isApiStatus: {
    ClientInvoiceListViewApi: "",
    ClientInvoiceDetailApi: "",
    ClientHideInvoiceApi: "",
  },
};

const clientinvoiceSlice = createSlice({
  name: "clientinvoice",
  initialState,
  reducers: {
    reset: () => initialState,
    OpenClientInvoiceDetails: (state, action) => {
      state.isOpenClientInvoiceDetailsTab = action.payload;
    },
    GetClientDetailTabInvoiceData: (state, action) => {
      state.isClientInvoiceDetailsTabData = action.payload;
      state.isClientInvoiceDetail = action.payload;
    },
    OpenClientInvoiceRefundModal: (state, action) => {
      state.isOpenClientInvoiceRefundModal = action.payload;
    },
    OpenClientInvoiceStripePayModalClient: (state, action) => {
      state.isOpenClientInvoiceStripePayModalClient = action.payload;
    },
    ClientInvoiceRefundData: (state, action) => {
      state.isSaleCompletedData = action.payload.isSaleCompletedData;
      state.AppointmentsData = action.payload.AppointmentsData;
      state.isRefundBalance = action.payload.balance;
    },
    OpenPartialPaidInvoice: (state, action) => {
      state.isOpenPartialPaidInvoice = action.payload;
    },
    ActiveBtnState: (state, action) => {
      state.isActiveBtnState = action.payload;
    },
    RefundStripeToken: (state, action) => {
      state.isRefundStripeToken = action.payload;
    },
    OpenStripeRefundModal: (state, action) => {
      state.isOpenStripeRefundModal = action.payload;
    },
    OpenStripeRefundCompletedSaleModal: (state, action) => {
      state.isOpenStripeRefundCompletedSaleModal = action.payload;
    },
    CompletedSaleDataForRefund: (state, action) => {
      state.isCompletedSaleDataForRefund = action.payload.isSaleCompletedData;
      state.appointmentsArray = action.payload.appointmentsArray;
      state.isdepositBalance = action.payload.isdepositBalance;
      state.isFullCartData = action.payload.FullCartData;
    },
    TaxAmountClientPaidInvoice: (state, action) => {
      state.isTaxAmountClientPaidInvoice = action.payload.taxAmounts;
      state.totalServiceCosts = action.payload.totalServiceCosts;
    },
    ClientMemberShipTotalPay: (state, action) => {
      state.isClientMemberShipTotalPay = action.payload;
    },
    InvoiceRedirectLoading: (state, action) => {
      state.isInvoiceRedirectLoading = !!action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(ClientInvoiceDetailApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientInvoiceDetailApi: "loading" };
      })
      .addCase(ClientInvoiceDetailApi.fulfilled, (state, action) => {
        state.isClientInvoiceDetail = action.payload;
        state.isApiStatus = { ...state.isApiStatus, ClientInvoiceDetailApi: "succeeded" };
      })
      .addCase(ClientInvoiceDetailApi.rejected, (state) => {
        state.isClientInvoiceDetail = [];
        state.isApiStatus = { ...state.isApiStatus, ClientInvoiceDetailApi: "failed" };
      })
      .addCase(ClientInvoiceListViewApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientInvoiceListViewApi: "loading" };
      })
      .addCase(ClientInvoiceListViewApi.fulfilled, (state, action) => {
        let old_current_page = state.isListView.current_page ? state.isListView.current_page : "";
        let new_current_page = action.payload.current_page ? action.payload.current_page : "";
        let viewdata = state.isListView && state.isListView.data;
        let newviewdata = action.payload && action.payload.data;
        state.isListView = action.payload;
        if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page != new_current_page) {
          viewdata && newviewdata ? (state.isListView.data = [...viewdata, ...newviewdata]) : action.payload;
        }
        state.isApiStatus = { ...state.isApiStatus, ClientInvoiceListViewApi: "succeeded" };
      })
      .addCase(ClientInvoiceListViewApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientInvoiceListViewApi: "failed" };
        state.isListView = [];
      })
      .addCase(ClientHideInvoiceApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientHideInvoiceApi: "loading" };
      })
      .addCase(ClientHideInvoiceApi.fulfilled, (state, action) => {
        const invoiceId = action.payload && action.payload.id;
        const targetActiveState = action.payload && action.payload.is_active;
        const isAdminList = action.payload && action.payload.adminClientInvoice;
        if (state.isListView && state.isListView.data && invoiceId) {
          if (targetActiveState === 0 || targetActiveState === "0") {
            if (isAdminList) {
              state.isListView.data = state.isListView.data.map((item) =>
                item.id === invoiceId ? { ...item, is_active: 0 } : item
              );
            } else {
              state.isListView.data = state.isListView.data.filter((item) => item.id !== invoiceId);
            }
          } else {
            state.isListView.data = state.isListView.data.map((item) =>
              item.id === invoiceId ? { ...item, is_active: 1 } : item
            );
          }
        }
        state.isApiStatus = { ...state.isApiStatus, ClientHideInvoiceApi: "succeeded" };
      })
      .addCase(ClientHideInvoiceApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientHideInvoiceApi: "failed" };
      });
  },
});
// Action creators are generated for each case reducer function
export const { reset, openNoteDrawer, closeNoteDrawer, openAddNoteForm, closeAddNoteForm, openEditNoteForm, closeEditNoteForm, OpenClientInvoiceDetails, GetClientDetailTabInvoiceData, OpenClientInvoiceRefundModal, OpenClientInvoiceStripePayModalClient, ClientInvoiceRefundData, OpenPartialPaidInvoice, ActiveBtnState, RefundStripeToken, OpenStripeRefundModal, OpenStripeRefundCompletedSaleModal, CompletedSaleDataForRefund, TaxAmountClientPaidInvoice, ClientMemberShipTotalPay, InvoiceRedirectLoading } = clientinvoiceSlice.actions;
export default clientinvoiceSlice.reducer;
